export const CONTROL_RATIO_SLICE = 'CONTROL_RATIO_SLICE';
